/**
 * Format a fraction as a percentage string suitable for display.
 *
 * Why a helper: a plain Math.round flattens sub-1% values to "0%", which
 * misreads as "nothing's wrong" when in reality a small but non-zero share
 * of products is affected (e.g. 23 of 9,454 → 0.24% → "0%"). EV feedback
 * flagged this on the Visibility / Priority Fix / Profile Completeness
 * cards. We render those non-zero sub-1% values as "<1%" so the badge
 * still pulls the eye.
 *
 * Pass raw numerator + denominator (NOT a pre-rounded pct), otherwise we
 * can't tell a true zero apart from a rounded-down sliver.
 */
export function formatPct(numerator, denominator) {
	if (!denominator || denominator <= 0) return '0%';
	if (numerator <= 0) return '0%';
	const raw = (numerator / denominator) * 100;
	if (raw > 0 && raw < 1) return '<1%';
	return `${Math.round(raw)}%`;
}

/**
 * Numeric companion for cases where the bar `width: …%` style needs a
 * value (the visual bar can't really show "<1%", so we floor at 1%).
 */
export function pctForBar(numerator, denominator) {
	if (!denominator || denominator <= 0) return 0;
	if (numerator <= 0) return 0;
	const raw = (numerator / denominator) * 100;
	if (raw > 0 && raw < 1) return 1;
	return Math.round(raw);
}
